// source: protocol_media_control.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var header_entity_pb = require('./header_entity_pb.js');
goog.object.extend(proto, header_entity_pb);
var signaling_param_pb = require('./signaling_param_pb.js');
goog.object.extend(proto, signaling_param_pb);
goog.exportSymbol('proto.himpb.EMedia', null, global);
goog.exportSymbol('proto.himpb.EMedia.EncodeType', null, global);
goog.exportSymbol('proto.himpb.EMedia.SourceType', null, global);
goog.exportSymbol('proto.himpb.MediaControlReq', null, global);
goog.exportSymbol('proto.himpb.MediaControlRsp', null, global);
goog.exportSymbol('proto.himpb.MediaStatusChangedNty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.EMedia = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.EMedia, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.EMedia.displayName = 'proto.himpb.EMedia';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MediaControlReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MediaControlReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.MediaControlReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MediaControlReq.displayName = 'proto.himpb.MediaControlReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MediaControlRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MediaControlRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.MediaControlRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MediaControlRsp.displayName = 'proto.himpb.MediaControlRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MediaStatusChangedNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MediaStatusChangedNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.MediaStatusChangedNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MediaStatusChangedNty.displayName = 'proto.himpb.MediaStatusChangedNty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.EMedia.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.EMedia.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.EMedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.EMedia.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.EMedia}
 */
proto.himpb.EMedia.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.EMedia;
  return proto.himpb.EMedia.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.EMedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.EMedia}
 */
proto.himpb.EMedia.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.EMedia.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.EMedia.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.EMedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.EMedia.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.himpb.EMedia.SourceType = {
  FROM_SIGNALING: 0,
  FROM_GROUP: 1
};

/**
 * @enum {number}
 */
proto.himpb.EMedia.EncodeType = {
  PB_ENCODE: 0,
  JSON_ENCODE: 1,
  BASE64_ENCODE: 2
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MediaControlReq.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MediaControlReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MediaControlReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MediaControlReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaControlReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    sourcetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sourceid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ownerid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    signaling_param_pb.TSigSessionControl.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MediaControlReq}
 */
proto.himpb.MediaControlReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MediaControlReq;
  return proto.himpb.MediaControlReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MediaControlReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MediaControlReq}
 */
proto.himpb.MediaControlReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EMedia.SourceType} */ (reader.readEnum());
      msg.setSourcetype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerid(value);
      break;
    case 5:
      var value = new signaling_param_pb.TSigSessionControl;
      reader.readMessage(value,signaling_param_pb.TSigSessionControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MediaControlReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MediaControlReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MediaControlReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaControlReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getSourcetype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSourceid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOwnerid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      signaling_param_pb.TSigSessionControl.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.MediaControlReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.MediaControlReq} returns this
*/
proto.himpb.MediaControlReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.MediaControlReq} returns this
 */
proto.himpb.MediaControlReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.MediaControlReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EMedia.SourceType sourceType = 2;
 * @return {!proto.himpb.EMedia.SourceType}
 */
proto.himpb.MediaControlReq.prototype.getSourcetype = function() {
  return /** @type {!proto.himpb.EMedia.SourceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EMedia.SourceType} value
 * @return {!proto.himpb.MediaControlReq} returns this
 */
proto.himpb.MediaControlReq.prototype.setSourcetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string sourceId = 3;
 * @return {string}
 */
proto.himpb.MediaControlReq.prototype.getSourceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaControlReq} returns this
 */
proto.himpb.MediaControlReq.prototype.setSourceid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ownerId = 4;
 * @return {string}
 */
proto.himpb.MediaControlReq.prototype.getOwnerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaControlReq} returns this
 */
proto.himpb.MediaControlReq.prototype.setOwnerid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated TSigSessionControl controls = 5;
 * @return {!Array<!proto.himpb.TSigSessionControl>}
 */
proto.himpb.MediaControlReq.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.himpb.TSigSessionControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigSessionControl, 5));
};


/**
 * @param {!Array<!proto.himpb.TSigSessionControl>} value
 * @return {!proto.himpb.MediaControlReq} returns this
*/
proto.himpb.MediaControlReq.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.himpb.TSigSessionControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.MediaControlReq.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.himpb.TSigSessionControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MediaControlReq} returns this
 */
proto.himpb.MediaControlReq.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MediaControlRsp.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MediaControlRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MediaControlRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MediaControlRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaControlRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    sourcetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sourceid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ownerid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    signaling_param_pb.TSigSessionControl.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MediaControlRsp}
 */
proto.himpb.MediaControlRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MediaControlRsp;
  return proto.himpb.MediaControlRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MediaControlRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MediaControlRsp}
 */
proto.himpb.MediaControlRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EMedia.SourceType} */ (reader.readEnum());
      msg.setSourcetype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerid(value);
      break;
    case 5:
      var value = new signaling_param_pb.TSigSessionControl;
      reader.readMessage(value,signaling_param_pb.TSigSessionControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MediaControlRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MediaControlRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MediaControlRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaControlRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getSourcetype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSourceid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOwnerid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      signaling_param_pb.TSigSessionControl.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.MediaControlRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.MediaControlRsp} returns this
*/
proto.himpb.MediaControlRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.MediaControlRsp} returns this
 */
proto.himpb.MediaControlRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.MediaControlRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EMedia.SourceType sourceType = 2;
 * @return {!proto.himpb.EMedia.SourceType}
 */
proto.himpb.MediaControlRsp.prototype.getSourcetype = function() {
  return /** @type {!proto.himpb.EMedia.SourceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EMedia.SourceType} value
 * @return {!proto.himpb.MediaControlRsp} returns this
 */
proto.himpb.MediaControlRsp.prototype.setSourcetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string sourceId = 3;
 * @return {string}
 */
proto.himpb.MediaControlRsp.prototype.getSourceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaControlRsp} returns this
 */
proto.himpb.MediaControlRsp.prototype.setSourceid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ownerId = 4;
 * @return {string}
 */
proto.himpb.MediaControlRsp.prototype.getOwnerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaControlRsp} returns this
 */
proto.himpb.MediaControlRsp.prototype.setOwnerid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated TSigSessionControl controls = 5;
 * @return {!Array<!proto.himpb.TSigSessionControl>}
 */
proto.himpb.MediaControlRsp.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.himpb.TSigSessionControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigSessionControl, 5));
};


/**
 * @param {!Array<!proto.himpb.TSigSessionControl>} value
 * @return {!proto.himpb.MediaControlRsp} returns this
*/
proto.himpb.MediaControlRsp.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.himpb.TSigSessionControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.MediaControlRsp.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.himpb.TSigSessionControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MediaControlRsp} returns this
 */
proto.himpb.MediaControlRsp.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MediaStatusChangedNty.repeatedFields_ = [6,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MediaStatusChangedNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MediaStatusChangedNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MediaStatusChangedNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaStatusChangedNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    sourcetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sourceid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    operatorid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ownerid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    signaling_param_pb.TSigSessionControl.toObject, includeInstance),
    receiversList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MediaStatusChangedNty}
 */
proto.himpb.MediaStatusChangedNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MediaStatusChangedNty;
  return proto.himpb.MediaStatusChangedNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MediaStatusChangedNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MediaStatusChangedNty}
 */
proto.himpb.MediaStatusChangedNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EMedia.SourceType} */ (reader.readEnum());
      msg.setSourcetype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperatorid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerid(value);
      break;
    case 6:
      var value = new signaling_param_pb.TSigSessionControl;
      reader.readMessage(value,signaling_param_pb.TSigSessionControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceivers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MediaStatusChangedNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MediaStatusChangedNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MediaStatusChangedNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaStatusChangedNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getSourcetype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSourceid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperatorid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOwnerid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      signaling_param_pb.TSigSessionControl.serializeBinaryToWriter
    );
  }
  f = message.getReceiversList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.MediaStatusChangedNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
*/
proto.himpb.MediaStatusChangedNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.MediaStatusChangedNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EMedia.SourceType sourceType = 2;
 * @return {!proto.himpb.EMedia.SourceType}
 */
proto.himpb.MediaStatusChangedNty.prototype.getSourcetype = function() {
  return /** @type {!proto.himpb.EMedia.SourceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EMedia.SourceType} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.setSourcetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string sourceId = 3;
 * @return {string}
 */
proto.himpb.MediaStatusChangedNty.prototype.getSourceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.setSourceid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string operatorId = 4;
 * @return {string}
 */
proto.himpb.MediaStatusChangedNty.prototype.getOperatorid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.setOperatorid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ownerId = 5;
 * @return {string}
 */
proto.himpb.MediaStatusChangedNty.prototype.getOwnerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.setOwnerid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated TSigSessionControl controls = 6;
 * @return {!Array<!proto.himpb.TSigSessionControl>}
 */
proto.himpb.MediaStatusChangedNty.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.himpb.TSigSessionControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigSessionControl, 6));
};


/**
 * @param {!Array<!proto.himpb.TSigSessionControl>} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
*/
proto.himpb.MediaStatusChangedNty.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.himpb.TSigSessionControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.MediaStatusChangedNty.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.himpb.TSigSessionControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * repeated string receivers = 15;
 * @return {!Array<string>}
 */
proto.himpb.MediaStatusChangedNty.prototype.getReceiversList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.setReceiversList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.addReceivers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MediaStatusChangedNty} returns this
 */
proto.himpb.MediaStatusChangedNty.prototype.clearReceiversList = function() {
  return this.setReceiversList([]);
};


goog.object.extend(exports, proto.himpb);
